import React from 'react';
import { Button } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import autoBind from 'auto-bind';

class OnOffButton extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  render() {
    const { couponActive, onClick } = this.props;
    return (
      <Button basic color={couponActive ? 'grey' : 'green'} onClick={onClick}>
        {couponActive ? 'Deactivate' : 'Activate'}
      </Button>
    );
  }
}

OnOffButton.propTypes = {
  couponActive: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
};

OnOffButton.defaultProps = {
  onClick: () => {},
};

export default OnOffButton;
